export default __webpack_public_path__ + "static/support-hero-bcdc0b9318d22c9abfb3bc62071e9867.jpg";